import { Avatar, Grid, Stack, Typography } from '@mui/material';
import { ContactUsMobileBackground, SupportMobile } from 'Images';

interface IContactUsProps {
  title?: string;
  description?: string;
  phoneNumber?: string;
  phoneNumberTel?: string;
}

export const ContactUsMobile = ({
  description,
  phoneNumber,
  phoneNumberTel,
  title,
}: IContactUsProps) => {
  return (
    <Stack
      alignItems='center'
      justifyContent='center'
      mt={3}
      mb={17.5}
      sx={{
        paddingX: '58px',
        paddingBottom: '24px',
        boxShadow: '0px 4px 28px rgba(45, 112, 217, 0.15)',
        borderRadius: '16px',
        height: '191.38px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Avatar
        src={ContactUsMobileBackground}
        alt={''}
        sx={{
          position: 'absolute',
          width: '240px',
          height: '200px',
          zIndex: '0',
          right: '0',
          bottom: '0',
          transform: 'translate(25%, 35%)',
        }}
      />
      <Grid item mt={3.5} mb={1}>
        <Avatar
          alt=''
          src={SupportMobile}
          sx={{
            width: '40px',
            height: '40px',
          }}
        />
      </Grid>
      <Grid
        item
        sx={{
          zIndex: '1',
        }}
      >
        <Typography
          sx={{
            fontSize: '18px',
            fontWeight: 700,
            lineHeight: '22px',
            textAlign: 'center',
            mb: 1,
          }}
        >
          {title || ''}
        </Typography>
        <Typography
          sx={{
            lineHeight: '22px',
            color: '#60727E',
            textAlign: 'center',
          }}
        >
          {description || ''}
        </Typography>
        <Grid item container justifyContent='center'>
          <Typography
            component='a'
            href={
              phoneNumberTel ? `tel:${phoneNumberTel}` : `tel:${phoneNumber}`
            }
            textAlign='center'
            mb={3}
            mt={2}
            sx={{
              fontWeight: 700,
              lineHeight: '20px',
              color: '#1752AF',
            }}
          >
            {phoneNumber || ''}
          </Typography>
        </Grid>
      </Grid>
    </Stack>
  );
};
